var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgText10(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 52,
    viewBox: "0 0 46 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 3001"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 3075"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    opacity: 0.9,
    d: "M13.8828 6.57031C13.8281 19.6953 12.6797 30.7422 6.60938 40.75L0.539062 37.5781C5.35156 29.7852 6.77344 22.5938 7.10156 12.8047H2.34375V6.57031H13.8828ZM25.1484 6.57031C25.1484 11 25.0664 15.293 24.7656 19.4219H28.2656V1.97656H35.6484V48.9531H28.2656V25.7109H24C22.9883 31.8359 21.1562 37.6055 17.875 42.9922L11.9141 39.7109C17.1367 31.2617 18.2305 23.1406 18.4766 12.8047H15.3047V6.57031H25.1484ZM45.7109 0.882812V51.0859H38.1641V0.882812H45.7109Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgText10);
export default __webpack_public_path__ + "static/media/text10.01b90657292addb7b77d10b4896f4ad7.svg";
export { ForwardRef as ReactComponent };